import { makeStyles } from '@mui/styles';
import { neutral3, neutral6 } from 'apollo-react/colors';
import Button from 'apollo-react/components/Button';
import IconButton from 'apollo-react/components/IconButton';
import Pagination from 'apollo-react/components/Pagination';
import Typography from 'apollo-react/components/Typography';
import ThumbsDown from 'apollo-react-icons/ThumbsDown';
import ThumbsUp from 'apollo-react-icons/ThumbsUp';
import React from 'react';

import { useTranslation } from '../../../custom-hooks/useTranslation';
import { getEnvVar } from '../../../utils/env';

const useStyles = makeStyles({
  columnTitle: {
    marginBottom: 5,
    color: neutral6,
  },
  answerSectionContainer: {
    height: 420,
    justifyContent: 'center',
  },
  answerTextContainer: {
    height: 280,
  },
  answerInfoContainer: {
    border: `1px solid ${neutral3}`,
    width: '100%',
    borderRadius: 4,
  },
  answerText: {
    padding: 10,
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    whiteSpace: 'pre-wrap',
  },
  answerActionsContainer: {
    padding: '0 10px',
    borderTop: `1px solid ${neutral3}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: 60,
  },
  pagination: {
    marginTop: 10,
    justifyContent: 'center',
  },
  rateButtonContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  rateIcon: {
    transform: 'scale(-1, 1)',
    marginLeft: 10,
  },
});

const getHelpUrl = (url) => {
  if (url) {
    return url.replace('$$smartsolveapplication$$', `${getEnvVar('REACT_APP_ADMIN_APP_URL')}/Help`);
  }
};

export const AnswerSection = (props) => {
  const { topicIndex, page, setPage, answerInfo } = props;

  const classes = useStyles();
  const translateString = useTranslation();

  const currentAnswer = answerInfo[topicIndex]?.Answers[page] ?? '';
  const answersLength = answerInfo[topicIndex]?.Answers?.length ?? 1;
  const helpUrl = getHelpUrl(currentAnswer.Url);

  return (
    <>
      <Typography className={classes.columnTitle}>{translateString('Answer')}</Typography>
      <div className={classes.answerInfoContainer}>
        <div className={classes.answerTextContainer}>
          <Typography className={classes.answerText}>
            {currentAnswer.Answer ?? translateString('No answers were found')}
          </Typography>
        </div>
        <div className={classes.answerActionsContainer}>
          <div className={classes.rateButtonContainer}>
            <Typography>{translateString('Was this answer helpful')}</Typography>
            <IconButton className={classes.rateIcon} disabled>
              <ThumbsUp />
            </IconButton>
            <IconButton disabled>
              <ThumbsDown />
            </IconButton>
          </div>
          <a href={helpUrl} target="_blank" rel="noopener noreferrer">
            <Button size="small" variant="secondary" disabled={!helpUrl}>
              {translateString('Open in Help')}
            </Button>
          </a>
        </div>
      </div>
      <Pagination
        className={classes.pagination}
        page={page}
        onChangePage={setPage}
        count={answersLength}
        rowsPerPage={1}
        pageText={translateString('Answer')}
      />
    </>
  );
};
